import { Github, Linkedin, Mail, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import ModernImage from "@/components/ModernImage";
import EN from "@/constants/en";

const About = () => {
    return (
        <section id="about" className="section bg-white">
            <div className="container-custom">
                <h2 className="section-title">{EN.ABOUT_SUMMARY_TITLE}</h2>
                <div className="grid md:grid-cols-3 gap-8">
                    <div className="md:col-span-2 sm:flex sm:gap-6">
                        <ModernImage
                            src="/uploads/marhaf-portrait.jpg"
                            alt={EN.META_AUTHOR}
                            width={176}
                            height={220}
                            className="mb-4 w-32 shrink-0 rounded-xl object-cover object-top shadow-md sm:mb-0 sm:w-44"
                            responsive={false}
                        />
                        <div>
                            <p className="text-lg leading-relaxed mb-6">{EN.ABOUT_PARAGRAPH1}</p>
                            <p className="text-lg leading-relaxed mb-6">{EN.ABOUT_PARAGRAPH2}</p>
                        </div>
                    </div>
                    <div className="bg-secondary rounded-lg p-6 shadow-sm">
                        <h3 className="text-xl font-semibold mb-4">{EN.ABOUT_CONTACT_INFO}</h3>
                        <div className="space-y-4">
                            <div className="flex items-center gap-3">
                                <MapPin className="h-5 w-5 text-accent" />
                                <span>{EN.ABOUT_LOCATION}</span>
                            </div>
                            <div className="flex items-center gap-3">
                                <Mail className="h-5 w-5 text-accent" />
                                <span>{EN.CONTACT_EMAIL}</span>
                            </div>
                            <div className="flex flex-wrap gap-2 mt-4">
                                <Button asChild variant="outline" size="sm" className="gap-2">
                                    <a href={EN.ABOUT_CONTACT_LINKEDIN_URL} target="_blank" rel="noopener noreferrer">
                                        <Linkedin className="h-4 w-4" /> {EN.ABOUT_CONTACT_LINKEDIN}
                                    </a>
                                </Button>
                                <Button asChild variant="outline" size="sm" className="gap-2">
                                    <a href={EN.ABOUT_CONTACT_GITHUB_URL} target="_blank" rel="noopener noreferrer">
                                        <Github className="h-4 w-4" /> {EN.ABOUT_CONTACT_GITHUB}
                                    </a>
                                </Button>
                            </div>
                            <div className="flex flex-wrap gap-2 mt-2">
                                <Button asChild variant="outline" size="sm">
                                    <a href={EN.ABOUT_CONTACT_SELFINTRO_URL} target="_blank" rel="noopener noreferrer">
                                        {EN.ABOUT_CONTACT_SELFINTRO}
                                    </a>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
